export default __webpack_public_path__ + "static/media/oola_black_logo.1ce19656.svg";